import { render, staticRenderFns } from "./BadgeTicket.vue?vue&type=template&id=274d1fe7&"
import script from "./BadgeTicket.vue?vue&type=script&lang=ts&"
export * from "./BadgeTicket.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports